import { FC } from "react"
import { IStudent } from "types"
import { useTableModel } from 'utils/tableModels/useRtiMeetingsTableModel'
import MainTable from "components/organisms/tables/MainTable"
import { useGET_meetingsQuery } from "redux/api/meetingsApi"
import { Tooltip, Button } from "@mui/material"
import { t } from "i18next"
import { useNavigate } from "react-router-dom"
import { Add } from "@mui/icons-material"
import { removeEmpty } from "utils/helpers"


interface IProps {
    student: IStudent
    tabText?: string
    tabKey?: string
}

const RtiMeetings: FC<IProps> = ({ student }) => {

    const navigate  =  useNavigate()

    const filters = {
        is_rti: 'true',
        student: student.student_profile_id
    }
    
    return (
        <MainTable
        useTableModel={useTableModel}
        getTableData={ useGET_meetingsQuery}
        filters={removeEmpty(filters)}
        header={<div style={{ textAlign: 'right', paddingBottom: '10px' }}>
            <Tooltip title={`${t('common.add-meeting')}`} arrow placement='top'>
              <Button
                  variant='contained'
                  color='success'
                  aria-haspopup='true'
                  onClick={() => navigate(`/meetings/add`)}
                  disableElevation
                  sx={{ 
                      lineHeight: '1rem'
                  }}
              >
                  <Add />                         
                  <span>{`${t('common.add-meeting')}`}</span>
              </Button>
          </Tooltip>
      </div>} />  
    )
       
}
export default RtiMeetings
